var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 337,
    height: 250,
    viewBox: "0 0 337 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336.72 99.2041L193.639 16.618C184.255 11.2019 176.617 17.0179 176.617 29.4857C176.617 41.9536 184.291 56.6025 193.639 62.0185L336.72 144.605V99.2041Z",
    fill: "#E8EDFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 121.631L181.6 16.3633L330.101 126.43L160.977 223.192L4.875 121.631Z",
    fill: "#CBD5F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.976 203.6L17.8574 121.05C8.51013 115.634 0.835938 121.414 0.835938 133.918C0.835938 146.386 8.51013 161.034 17.8574 166.451L160.939 249.037V203.6H160.976Z",
    fill: "#E8EDFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M336.719 99.2041L160.977 203.6V249L336.719 144.605V99.2041Z",
    fill: "#E8EDFB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M160.971 212.433L19.0896 130.901C13.1249 127.448 8.21484 131.156 8.21484 139.116C8.21484 147.077 13.0885 156.419 19.0896 159.836L160.971 241.695V212.433Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M336.719 108L160.977 212.396V241.694L336.719 137.298V108Z",
    fill: "#F7F7F7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M160.881 194.946L23.1094 115.559L186.922 21.0137L324.694 100.401L160.881 194.946ZM28.2376 115.341L161.281 192.002L319.639 100.619L186.559 23.958L28.2376 115.341Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M322.043 100.44C314.332 96.4418 313.75 96.8053 307.895 93.4248C299.348 98.3683 298.257 105.711 305.203 110.182L322.043 100.44Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M186.038 23.2314L170.145 32.3915C177.819 36.6081 190.876 36.0265 199.568 31.0102C192.149 26.7573 186.038 23.2314 186.038 23.2314Z",
    fill: "#65659B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M176.809 184.224C169.098 180.226 156.332 180.844 147.785 185.787C154.368 189.567 160.951 193.384 160.951 193.384L176.809 184.224Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8353 106.437L25.9414 115.597C33.6156 119.813 36.1615 121.485 39.4713 123.412C48.1638 118.396 49.1458 110.835 41.8353 106.437Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M201.982 1.98975L308.296 63.332C309.961 64.2923 310.986 66.0677 310.986 67.9892V100.331C310.986 104.469 306.507 107.056 302.922 104.988L201.982 46.7466C192.752 41.4305 185.203 27.0067 185.203 14.6937C185.203 2.38064 192.752 -3.32634 201.982 1.98975Z",
    fill: "url(#paint0_linear_4722_76062)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M201.982 1.98975L308.296 63.332C309.961 64.2923 310.986 66.0677 310.986 67.9892V100.331C310.986 104.469 306.507 107.056 302.922 104.988L201.982 46.7466C192.752 41.4305 185.203 27.0067 185.203 14.6937C185.203 2.38064 192.752 -3.32634 201.982 1.98975Z",
    fill: "url(#paint1_linear_4722_76062)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M161.188 153.539L310.985 64.8857V109.643L161.188 198.296V153.539Z",
    fill: "#F7B689"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M161.188 153.539L310.985 64.8857V109.643L161.188 198.296V153.539Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3477 89.7054L188.432 2.70446C190.044 1.75069 192.037 1.70496 193.691 2.58376L302.52 60.3888C306.228 62.358 306.349 67.6265 302.736 69.7645L163.785 151.999C162.171 152.955 160.175 152.999 158.519 152.117L41.3477 89.7054Z",
    fill: "url(#paint2_linear_4722_76062)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3477 89.7054L188.432 2.70446C190.044 1.75069 192.037 1.70496 193.691 2.58376L302.52 60.3888C306.228 62.358 306.349 67.6265 302.736 69.7645L163.785 151.999C162.171 152.955 160.175 152.999 158.519 152.117L41.3477 89.7054Z",
    fill: "url(#paint3_linear_4722_76062)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M105.816 87.1364C102.902 85.4594 102.952 81.2375 105.905 79.6301L189.935 33.8927C191.185 33.2121 192.691 33.1943 193.957 33.8451L247.755 61.4982C250.782 63.0541 250.889 67.3425 247.943 69.047L163.548 117.88C162.218 118.649 160.579 118.651 159.248 117.885L105.816 87.1364Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1853 90.644L161.189 153.538V198.295L52.1853 135.401C42.9549 130.085 35.4064 115.661 35.4064 103.348C35.3673 91.0349 42.9549 85.328 52.1853 90.644Z",
    fill: "#F7B689"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1853 90.644L161.189 153.538V198.295L52.1853 135.401C42.9549 130.085 35.4064 115.661 35.4064 103.348C35.3673 91.0349 42.9549 85.328 52.1853 90.644Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M161.188 161.472L310.985 72.8184V101.94L161.188 190.593V161.472Z",
    fill: "#F7F7F7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3771 98.7747L161.186 161.473V190.595L52.3771 128.17C46.3148 124.652 41.3477 115.192 41.3477 107.101C41.3477 99.0092 46.3148 95.2567 52.3771 98.7747Z",
    fill: "#FBFCFD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M157.157 137.872C158.154 138.444 159.38 138.442 160.375 137.868L281.031 68.2493C283.186 67.0062 283.182 63.8955 281.025 62.6571L196.96 14.3992C195.963 13.8268 194.737 13.8283 193.741 14.4031L73.0856 84.0568C70.9313 85.3004 70.9355 88.4113 73.0932 89.6491L157.157 137.872ZM274.306 62.658C276.464 63.8957 276.468 67.0072 274.314 68.2507L160.375 134.005C159.38 134.579 158.154 134.581 157.157 134.009L79.8461 89.6493C77.6886 88.4114 77.6845 85.3007 79.8387 84.0571L193.742 18.3026C194.737 17.728 195.963 17.7263 196.96 18.298L274.306 62.658Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M275.114 61.2841C274.814 61.4716 274.476 61.6216 274.214 61.8091C270.312 64.6215 270.424 68.3339 274.326 70.4338L270.912 72.3837C270.837 72.3462 270.724 72.3087 270.649 72.2712C265.546 69.3088 265.509 64.209 270.874 60.3842C271.287 60.0842 271.737 59.8592 272.188 59.5967L275.114 61.2841Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M202.196 19.5107C201.896 19.6982 201.595 19.8857 201.258 20.0357C196.418 22.2856 189.964 22.2106 186.325 19.9607L182.91 21.9107C182.985 21.9482 183.06 22.0232 183.135 22.0607C188.238 25.0231 197.093 25.0231 203.734 21.9107C204.222 21.6857 204.635 21.4232 205.085 21.1607L202.196 19.5107Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M151.522 132.645C151.822 132.457 152.122 132.27 152.46 132.12C157.3 129.87 163.754 129.945 167.393 132.195L170.807 130.245C170.732 130.207 170.657 130.133 170.582 130.095C165.479 127.133 156.625 127.133 149.984 130.245C149.496 130.47 149.083 130.732 148.633 130.995L151.522 132.645Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5664 90.8359C78.8666 90.6485 79.2043 90.4985 79.4669 90.311C83.369 87.4986 83.2565 83.7862 79.3543 81.6863L82.7687 79.7363C82.8437 79.7738 82.9563 79.8113 83.0313 79.8488C88.1341 82.8112 88.1716 87.911 82.8062 91.7359C82.3935 92.0359 81.9432 92.2609 81.493 92.5234L78.5664 90.8359Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1279 135.637C72.1279 135.637 62.9366 144.393 59.8468 146.192C56.0139 148.42 44.5151 155.026 44.5151 155.026L45.4146 147.599L32.5078 148.107C32.5078 148.107 44.0066 141.462 47.8396 139.273C50.8903 137.514 60.1206 128.719 60.1206 128.719L72.1279 135.637Z",
    fill: "#EC4E7C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4722_76062",
    x1: 194.188,
    y1: 18.2735,
    x2: 239.744,
    y2: 112.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67D76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4722_76062",
    x1: 203.785,
    y1: 18.9763,
    x2: 293.202,
    y2: 92.5197,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6988B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4722_76062",
    x1: 60.6073,
    y1: 26.5637,
    x2: 106.704,
    y2: 173.81,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9FBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F67D76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4722_76062",
    x1: 81.1802,
    y1: 27.5405,
    x2: 204.321,
    y2: 183.768,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8D786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6988B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarImg);
export default __webpack_public_path__ + "static/media/calendarImg.2ae13555.svg";
export { ForwardRef as ReactComponent };